<div app-landing-page-section-container>
    <div class="flex flex-col mx-auto lg:max-w-[900px] items-center">
        <div class="mat-headline-6 text-center">
            {{ title | translate }}
        </div>

        <h5
            class="text-center success-subtitle"
            data-qa="landing-page_register-success-title"
        >
            {{ subTitle | translate }}
        </h5>

        <div
            *ngIf="showNextSteps"
            class="grid gap-4 mt-12 md:mt-16 mb-0 md:mb-4 text-left place-items-start items-center md:gap-y-10"
        >
            <div
                class="rounded-full h-12 w-12 md:h-14 md:w-14 flex items-center justify-center bg-white text-primary text-xl"
            >
                1
            </div>
            <div class="text-lg md:text-xl" translate>
                We check your details.
            </div>

            <div
                class="rounded-full h-12 w-12 md:h-14 md:w-14 flex items-center justify-center bg-white text-primary text-xl"
            >
                2
            </div>
            <div class="text-lg md:text-xl" translate>
                Your traigo access is activated.
            </div>

            <div
                class="rounded-full h-12 w-12 md:h-14 md:w-14 flex items-center justify-center bg-white text-primary text-xl"
            >
                3
            </div>
            <div class="text-lg md:text-xl" translate>
                You receive a confirmation email from us.
            </div>
        </div>

        <app-button-group alignment="center" class="mt-12 pb-10">
            <app-button
                (buttonClick)="handleBackClick()"
                data-qa="landing-page_register-success-back-button"
            >
                <translate>Go back to landing page</translate>
            </app-button>
        </app-button-group>
    </div>
</div>
